import React, { useEffect, useRef, useState } from 'react'
import $ from "jquery";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import jszip from "jszip";
import { Link } from 'react-router-dom';
pdfMake.vfs = pdfFonts.vfs;

const UserManagement = () => {

    const table1 = useRef(null);
    const table2 = useRef(null);
    const table3 = useRef(null);

    useEffect(() => {
        window.JSZip = jszip;

        let table11, table12, table13;

        if (table1.current) {
            table11 = $(table1.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }

        if (table2.current) {
            table12 = $(table2.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }
        if (table3.current) {
            table13 = $(table3.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }
        return () => {
            if (table11) table11.destroy();
            if (table12) table12.destroy();
            if (table13) table13.destroy();
        };
    }, []);

    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">User Management</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">User Management</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <ul className="nav nav-tabs mb-3" id="pricingTabs" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button className="nav-link active" id="platform-fees-tab" data-bs-toggle="tab" data-bs-target="#platformFees" type="button" role="tab">
                                All
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link" id="cancellation-rules-tab" data-bs-toggle="tab" data-bs-target="#cancellationRules" type="button" role="tab">
                                active
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link" id="executed-tab" data-bs-toggle="tab" data-bs-target="#executed " type="button" role="tab">
                                blocked
                            </button>
                        </li>
                    </ul>
                    <div className="tab-content mt-5" id="pricingTabsContent">
                        <div className="tab-pane fade show active" id="platformFees" role="tabpanel">
                            <div className="entries-wrapper mb-3">
                                <label className="entries-label">
                                    <span>Showing</span>
                                    <select className="entries-select">
                                        <option value={10} selected>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                    <span>Entries</span>
                                </label>
                            </div>
                            <div className="card radius-10">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div className="table-responsive">
                                            <table className="table table-striped table-bordered align-middle" ref={table1}>
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>Profile Photo</th>
                                                        <th>First Name</th>
                                                        <th>Last Name</th>
                                                        <th>User Name</th>
                                                        <th>Email</th>
                                                        <th>Phone Number</th>
                                                        <th>Subscription Plan</th>
                                                        <th>SEE</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td><img src="images/avatars/avatar-1.png" className="rounded-circle" width={40} height={40} /></td>
                                                        <td>John</td>
                                                        <td>Doe</td>
                                                        <td>@john_doe</td>
                                                        <td>john.doe@email.com</td>
                                                        <td>(511)-234-5678</td>
                                                        <td><select className="status-select" disabled>
                                                            <option selected>Premium</option>
                                                        </select></td>
                                                        <td>16</td>
                                                        <td>
                                                            <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                                <li><Link to="/user-management-detail"><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#decline_modal"><i className="bx bx-block" data-bs-toggle="tooltip" title="Block" /></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#deleteRenterModal"><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></Link></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><img src="images/avatars/avatar-2.png" className="rounded-circle" width={40} height={40} /></td>
                                                        <td>Sarah</td>
                                                        <td>Smith</td>
                                                        <td>@sarah_smith</td>
                                                        <td>sarah.smith@email.com</td>
                                                        <td>(415)-678-4321</td>
                                                        <td><select className="status-select" disabled>
                                                            <option selected>Free</option>
                                                        </select></td>
                                                        <td>4</td>
                                                        <td>
                                                            <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                                <li><Link to="/user-management-detail"><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#decline_modal"><i className="bx bx-block" data-bs-toggle="tooltip" title="Block" /></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#deleteRenterModal"><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></Link></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><img src="images/avatars/avatar-4.png" className="rounded-circle" width={40} height={40} /></td>
                                                        <td>Michael</td>
                                                        <td>Brown</td>
                                                        <td>@mike_b</td>
                                                        <td>michael.b@email.com</td>
                                                        <td>(212)-555-0198</td>
                                                        <td><select className="status-select" disabled>
                                                            <option selected>Basic</option>
                                                        </select></td>
                                                        <td>2</td>
                                                        <td>
                                                            <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                                <li><Link to="/user-management-detail"><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#decline_modal"><i className="bx bx-block" data-bs-toggle="tooltip" title="Block" /></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#deleteRenterModal"><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></Link></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><img src="images/avatars/avatar-3.png" className="rounded-circle" width={40} height={40} /></td>
                                                        <td>Emily</td>
                                                        <td>Johnson</td>
                                                        <td>@emily_j</td>
                                                        <td>emily.j@email.com</td>
                                                        <td>(305)-987-6543</td>
                                                        <td><select className="status-select" disabled>
                                                            <option selected>Premium</option>
                                                        </select></td>
                                                        <td>16</td>
                                                        <td>
                                                            <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                                <li><Link to="/user-management-detail"><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#decline_modal"><i className="bx bx-block" data-bs-toggle="tooltip" title="Block" /></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#deleteRenterModal"><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></Link></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane fade" id="cancellationRules" role="tabpanel">
                            <div className="entries-wrapper mb-3">
                                <label className="entries-label">
                                    <span>Showing</span>
                                    <select className="entries-select">
                                        <option value={10} selected>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                    <span>Entries</span>
                                </label>
                            </div>
                            <div className="card radius-10">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div className="table-responsive">
                                            <table className="table table-striped table-bordered align-middle" ref={table2}>
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>Profile Photo</th>
                                                        <th>First Name</th>
                                                        <th>Last Name</th>
                                                        <th>User Name</th>
                                                        <th>Email</th>
                                                        <th>Phone Number</th>
                                                        <th>Subscription Plan</th>
                                                        <th>SEE</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td><img src="images/avatars/avatar-1.png" className="rounded-circle" width={40} height={40} /></td>
                                                        <td>John</td>
                                                        <td>Doe</td>
                                                        <td>@john_doe</td>
                                                        <td>john.doe@email.com</td>
                                                        <td>(511)-234-5678</td>
                                                        <td><select className="status-select" disabled>
                                                            <option selected>Premium</option>
                                                        </select></td>
                                                        <td>16</td>
                                                        <td>
                                                            <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                                <li><Link to="/user-management-detail"><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#decline_modal"><i className="bx bx-block" data-bs-toggle="tooltip" title="Block" /></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#deleteRenterModal"><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></Link></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><img src="images/avatars/avatar-2.png" className="rounded-circle" width={40} height={40} /></td>
                                                        <td>Sarah</td>
                                                        <td>Smith</td>
                                                        <td>@sarah_smith</td>
                                                        <td>sarah.smith@email.com</td>
                                                        <td>(415)-678-4321</td>
                                                        <td><select className="status-select" disabled>
                                                            <option selected>Free</option>
                                                        </select></td>
                                                        <td>4</td>
                                                        <td>
                                                            <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                                <li><Link to="/user-management-detail"><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#decline_modal"><i className="bx bx-block" data-bs-toggle="tooltip" title="Block" /></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#deleteRenterModal"><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></Link></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><img src="images/avatars/avatar-4.png" className="rounded-circle" width={40} height={40} /></td>
                                                        <td>Michael</td>
                                                        <td>Brown</td>
                                                        <td>@mike_b</td>
                                                        <td>michael.b@email.com</td>
                                                        <td>(212)-555-0198</td>
                                                        <td><select className="status-select" disabled>
                                                            <option selected>Basic</option>
                                                        </select></td>
                                                        <td>2</td>
                                                        <td>
                                                            <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                                <li><Link to="/user-management-detail"><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#decline_modal"><i className="bx bx-block" data-bs-toggle="tooltip" title="Block" /></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#deleteRenterModal"><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></Link></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><img src="images/avatars/avatar-3.png" className="rounded-circle" width={40} height={40} /></td>
                                                        <td>Emily</td>
                                                        <td>Johnson</td>
                                                        <td>@emily_j</td>
                                                        <td>emily.j@email.com</td>
                                                        <td>(305)-987-6543</td>
                                                        <td><select className="status-select" disabled>
                                                            <option selected>Premium</option>
                                                        </select></td>
                                                        <td>16</td>
                                                        <td>
                                                            <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                                <li><Link to="/user-management-detail"><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#decline_modal"><i className="bx bx-block" data-bs-toggle="tooltip" title="Block" /></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#deleteRenterModal"><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></Link></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane fade" id="executed" role="tabpanel">
                            <div className="entries-wrapper mb-3">
                                <label className="entries-label">
                                    <span>Showing</span>
                                    <select className="entries-select">
                                        <option value={10} selected>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                    <span>Entries</span>
                                </label>
                            </div>
                            <div className="card radius-10">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div className="table-responsive">
                                            <table className="table table-striped table-bordered align-middle" ref={table3}>
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>Profile Photo</th>
                                                        <th>First Name</th>
                                                        <th>Last Name</th>
                                                        <th>User Name</th>
                                                        <th>Email</th>
                                                        <th>Phone Number</th>
                                                        <th>Subscription Plan</th>
                                                        <th>SEE</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td><img src="images/avatars/avatar-1.png" className="rounded-circle" width={40} height={40} /></td>
                                                        <td>John</td>
                                                        <td>Doe</td>
                                                        <td>@john_doe</td>
                                                        <td>john.doe@email.com</td>
                                                        <td>(511)-234-5678</td>
                                                        <td><select className="status-select" disabled>
                                                            <option selected>Premium</option>
                                                        </select></td>
                                                        <td>16</td>
                                                        <td>
                                                            <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                                <li><Link to="/user-management-detail"><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#decline_modal"><i className="bx bx-block" data-bs-toggle="tooltip" title="Block" /></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#deleteRenterModal"><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></Link></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><img src="images/avatars/avatar-2.png" className="rounded-circle" width={40} height={40} /></td>
                                                        <td>Sarah</td>
                                                        <td>Smith</td>
                                                        <td>@sarah_smith</td>
                                                        <td>sarah.smith@email.com</td>
                                                        <td>(415)-678-4321</td>
                                                        <td><select className="status-select" disabled>
                                                            <option selected>Free</option>
                                                        </select></td>
                                                        <td>4</td>
                                                        <td>
                                                            <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                                <li><Link to="/user-management-detail"><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#decline_modal"><i className="bx bx-block" data-bs-toggle="tooltip" title="Block" /></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#deleteRenterModal"><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></Link></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><img src="images/avatars/avatar-4.png" className="rounded-circle" width={40} height={40} /></td>
                                                        <td>Michael</td>
                                                        <td>Brown</td>
                                                        <td>@mike_b</td>
                                                        <td>michael.b@email.com</td>
                                                        <td>(212)-555-0198</td>
                                                        <td><select className="status-select" disabled>
                                                            <option selected>Basic</option>
                                                        </select></td>
                                                        <td>2</td>
                                                        <td>
                                                            <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                                <li><Link to="/user-management-detail"><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#decline_modal"><i className="bx bx-block" data-bs-toggle="tooltip" title="Block" /></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#deleteRenterModal"><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></Link></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><img src="images/avatars/avatar-3.png" className="rounded-circle" width={40} height={40} /></td>
                                                        <td>Emily</td>
                                                        <td>Johnson</td>
                                                        <td>@emily_j</td>
                                                        <td>emily.j@email.com</td>
                                                        <td>(305)-987-6543</td>
                                                        <td><select className="status-select" disabled>
                                                            <option selected>Premium</option>
                                                        </select></td>
                                                        <td>16</td>
                                                        <td>
                                                            <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                                <li><Link to="/user-management-detail"><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#decline_modal"><i className="bx bx-block" data-bs-toggle="tooltip" title="Block" /></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#deleteRenterModal"><i className="bx bx-trash" data-bs-toggle="tooltip" title="Delete" /></Link></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="deleteRenterModal" tabIndex={-1} aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content border-0">
                        <div className="modal-header">
                            <h5 className="modal-title">Confirmation alert!</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body delete-heading">
                            <i className="bi bi-trash fs-1 mb-3" />
                            <h5>Are you sure you want to delete this user?</h5>
                        </div>
                        <div className="modal-footer justify-content-center">
                            <button className="btn btn-decline" data-bs-dismiss="modal">No</button>
                            <button className="btn btn-approve px-4">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="decline_modal" tabIndex={-1} aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content border-0">
                        <div className="modal-header">
                            <h5 className="modal-title">Confirmation alert!</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <label className="form-label">Reason for blocking:</label>
                            <textarea className="form-control" rows={3} placeholder="Enter reason..." defaultValue={""} />
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-decline" data-bs-dismiss="modal">No</button>
                            <button className="btn btn-approve text-white px-4">Yes</button>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default UserManagement